import { getDbSupabase } from './supabase';
import { formatSupabaseError } from './formatSupabaseError';

export interface BulkChangeSalespersonCodeParams {
  toCode: string;
  fromCode?: string | null;
  clientIds?: Array<string | number> | null;
  includeSubCompanies?: boolean;
}

/** Elevated-only immediate update of clients.owner_id. Returns rows updated. */
export async function bulkChangeSalespersonCode(
  params: BulkChangeSalespersonCodeParams,
): Promise<number> {
  const toCode = params.toCode.trim();
  if (!toCode) throw new Error('Select the new salesperson code.');

  const clientIds =
    params.clientIds && params.clientIds.length > 0
      ? params.clientIds.map((id) => Number(id)).filter((n) => Number.isFinite(n))
      : null;

  const { data, error } = await getDbSupabase().rpc('bulk_change_salesperson_code', {
    p_to_code: toCode,
    p_from_code: clientIds ? null : (params.fromCode?.trim() || null),
    p_client_ids: clientIds,
    p_include_sub_companies: params.includeSubCompanies ?? false,
  });
  if (error) throw new Error(formatSupabaseError(error));
  return typeof data === 'number' ? data : Number(data) || 0;
}
